import fetch from "@lib/fetch";
import { API } from "../../config";
import {isAuthenticated} from "./auth";
import axios from 'axios';
import moment from 'moment';
import { normalizeCourierServices } from "../../services/helpers/courier";
import { normalizeMarketPlaceFile } from "../../services/helpers/importMarkteplaceOrder";

export const createOrder = async (token, data, destinations, uploadOrders) => {
  let time;

  if (destinations && data.deliveryType === 'many') {
    const arrDestinations = destinations.reduce((r,i) => {
      r.push({
        contact_name:i.name,
        contact_phone:i.phone,
        coordinate:i.coordinate,
        address:i.location,
        note:i.note,
        postal_code:i.postalCode,
        items: i.items,
        delivery_date:i.deliveryDate,
        delivery_time:i.deliveryTime,
        courier_company:i.courierCompanyCode,
        courier_type:i.courierTypeCode
      });
      return r
    },[]);

    let order = {
      origin_contact_name: data.originName,
      origin_address: data.originLocation,
      origin_contact_phone: data.originPhone,
      origin_note: data.originNote,
      origin_postal_code: data.originPostalCode,
      origin_coordinate: data.originCoordinate,
      payment_method: data.paymentMethod,
      note: data.note,
      type: 'dashboardManyDestinations',
      destinations: arrDestinations
    };

    return fetch(`${API}/v1/orders`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(order)
    })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
  } else if (data.deliveryType === 'upload') {
    let failedOrders = 0;
    let successOrders = 0;
    for (let i = 0; i < uploadOrders.length; i++) {

      let od = uploadOrders[i];
      let orderData = {
        destination_contact_name: od.receiverName,
        destination_contact_phone: od.receiverPhone,
        destination_postal_code: od.receiverPostalCode,
        destination_address: od.receiverLocation,
        destination_note: od.receiverNote,
        destination_coordinate: {latitude: od.receiverLatitude, longitude: od.receiverLongitude},
        destination_cash_on_delivery: od.receiverCODAmount,
        destination_cash_on_delivery_note: od.receiverCashOnDeliveryNote,
        destination_proof_of_delivery: od.receiverProofOfDelivery,
        destination_proof_of_delivery_note: od.receiverProofOfDeliveryNote,
        items: od.items,
        origin_contact_name: od.originName,
        origin_address: od.originLocation,
        origin_contact_phone: od.originPhone,
        origin_note: od.originNote,
        origin_coordinate: {latitude: od.originLatitude, longitude: od.originLongitude},
        origin_postal_code: od.originPostalCode,
        courier_company: od.courierCompany,
        courier_type: od.courierType,
        delivery_date: od.deliveryDate,
        delivery_time: od.deliveryTime,
        delivery_type: od.deliveryType,
        payment_method: data.paymentMethod,
        order_note: od.orderNote,
        tags: od.tags,
        type: 'dashboardUploadOrderFile'
      };

      await fetch(`${API}/v1/orders`,{
        mode: 'cors',
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(orderData)
      })
      .then(async res => {
        let response = await res.json();
        if (response.success) {
          successOrders++
        } else {
          failedOrders++
        }
      })
      .catch(err => {
        failedOrders++
      })
    }

    return {
      successOrders,
      failedOrders
    }

  } else {
    if (data.deliveryType === 'later') {
      time = data.deliveryTime
    } else {
      time = moment().format("HH:mm:ss")
    }

    let order = {
      destination_contact_name: data.receiverName,
      destination_contact_phone: data.receiverPhone,
      destination_address: data.receiverLocation,
      destination_note: data.receiverNote,
      destination_coordinate: data.receiverCoordinate,
      destination_cash_on_delivery: data.receiverCashOnDelivery ? data.receiverCashOnDeliveryAmount : null,
      destination_cash_on_delivery_note: data.receiverCashOnDeliveryNote,
      destination_cash_on_delivery_type: data.receiverCashOnDeliveryType,
      destination_proof_of_delivery: data.receiverProofOfDelivery,
      destination_proof_of_delivery_note: data.receiverProofOfDeliveryNote,
      items: data.orderItems,
      origin_contact_name: data.originName,
      origin_address: data.originLocation,
      origin_contact_phone: data.originPhone,
      origin_note: data.originNote,
      origin_coordinate: data.originCoordinate,
      courier_company: data.courierCompany,
      courier_type: normalizeCourierServices(data.courierCompany,data.courierType).typeSnakeFormat,
      courier_insurance: data.courierInsurance ? data.courierInsuranceAmount : null,
      delivery_date: moment(data.deliveryDate).format("YYYY-MM-DD"),
      delivery_time: time,
      delivery_type: data.deliveryType,
      price: data.price,
      extra: data.extra,
      payment_method: data.paymentMethod,
      order_note: data.orderNote,
      type: 'dashboard'
    };

    return fetch(`${API}/v1/orders`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(order)
    })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
  }

};

export const createFormOrder = async (data) => {
  let orderItems;

  if (
      data.fieldAdditionalItem &&
      data.additionalItemPrice > 0 &&
      data.additionalItemCourierBased === 'non-instant' &&
      !(data.courierCompany === 'gojek' || data.courierCompany ==='grab')
  ) {
    orderItems = data.orderItems;
    orderItems.push({
      name: data.additionalItemName,
      description: ``,
      value: data.additionalItemPrice,
      quantity: 1,
      height: 10,
      length: 10,
      width: 10,
      weight: 1000
    })
  } else if (
      data.fieldAdditionalItem &&
      data.additionalItemCourierBased === 'instant' &&
      data.additionalItemPrice > 0 &&
      (data.courierCompany === 'gojek' || data.courierCompany ==='grab')
  ) {
    orderItems = data.orderItems;
    orderItems.push({
      name: data.additionalItemName,
      description: ``,
      value: data.additionalItemPrice,
      quantity: 1,
      height: 10,
      length: 10,
      width: 10,
      weight: 1000
    })
  } else {
    orderItems = data.orderItems
  }

  let order = {
    destination_contact_name: data.receiverName,
    destination_contact_phone: `62`+data.receiverPhone,
    destination_email: data.receiverEmail,
    destination_address: data.receiverLocation,
    destination_note: data.receiverNote,
    destination_postal_code: data.receiverPostalCode,
    destination_coordinate: data.receiverCoordinate,
    items: orderItems,
    origin_contact_name: data.addressName,
    origin_contact_phone: data.addressPhone,
    origin_address: data.addressLocation,
    origin_note: data.addressNote,
    origin_coordinate: data.addressCoordinate,
    courier_company: data.courierCompany,
    courier_type: data.courierType,
    delivery_date: data.deliveryDate,
    delivery_time: data.deliveryTime,
    delivery_type: 'later',
    weight: data.weight,
    volume: data.volume,
    payment_type: 'online',
    payment_slip: data.paymentSlip,
    price: data.price,
    order_note: data.orderNote,
    unique_payment_code: data.uniqueCode,
    header_image: data.style.headerImage,
    type: 'form'
  };

  return fetch(`${API}/v1/order/form/create/${data.catalogId}/${data.userId}`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(order)
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const createAdminOrder = (userId, token, data, destinations, uploadOrders) => {
  let time;

  if (destinations && data.deliveryType === 'many') {
    const arrDestinations = destinations.reduce((r,i) => {
      r.push({
        contact_name:i.name,
        contact_phone:i.phone,
        coordinate:i.coordinate,
        address:i.location,
        note:i.note,
        postal_code:i.postalCode,
        items: i.items,
        delivery_date:i.deliveryDate,
        delivery_time:i.deliveryTime,
        courier_company:i.courierCompanyCode,
        courier_type:i.courierTypeCode
      });
      return r
    },[]);

    let order = {
      origin_contact_name: data.originName,
      origin_address: data.originLocation,
      origin_contact_phone: data.originPhone,
      origin_note: data.originNote,
      origin_postal_code: data.originPostalCode,
      origin_coordinate: data.originCoordinate,
      payment_method: data.paymentMethod,
      note: data.note,
      type: 'dashboardManyDestinationsByAdmin',
      destinations: arrDestinations
    };

    return fetch(`${API}/v1/admin/orders/users/${userId}`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(order)
    })
        .then(response => {
          return response.json()
        })
        .catch(error => {
          console.log(error);
        })
  } else if (data.deliveryType === 'upload') {
    // for upload orders
      return alert("belum bisa")
  } else {
    if (data.deliveryType === 'later') {
      time = data.deliveryTime
    } else {
      time = moment().format("HH:mm:ss")
    }

    let order = {
      destination_contact_name: data.receiverName,
      destination_contact_phone: data.receiverPhone,
      destination_address: data.receiverLocation,
      destination_note: data.receiverNote,
      destination_coordinate: data.receiverCoordinate,
      destination_cash_on_delivery: data.paymentType === 'offline' ? data.price : null,
      destination_cash_on_delivery_note: data.receiverCashOnDeliveryNote,
      destination_proof_of_delivery: data.receiverProofOfDelivery,
      destination_proof_of_delivery_note: data.receiverProofOfDeliveryNote,
      items: data.orderItems,
      extra: data.extra,
      origin_contact_name: data.originName,
      origin_address: data.originLocation,
      origin_contact_phone: data.originPhone,
      origin_note: data.originNote,
      origin_coordinate: data.originCoordinate,
      courier_company: data.courierCompany,
      courier_type: normalizeCourierServices(data.courierCompany,data.courierType).typeSnakeFormat,
      delivery_date: moment(data.deliveryDate).format("YYYY-MM-DD"),
      delivery_time: time,
      delivery_type: data.deliveryType,
      weight: data.weight,
      volume: data.volume,
      price: data.price,
      order_note: data.orderNote,
      payment_method: data.paymentMethod,
      type: 'dashboardByAdmin'
    };

    return fetch(`${API}/v1/admin/orders/users/${userId}`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(order)
    })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
  }
};

export const createMultipleOrders = async (token, orders, extra) => {
  let failedOrders = 0;
  let successOrders = 0;
  for (let i = 0; i < orders.length; i++) {
    let order = {
      ...orders[i],
      paymentMethod:extra.paymentMethod
    }
    let data = formatAPIOrder(order,'shopifyDashboard');
    await fetch(`${API}/v1/orders`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    })
    .then(async res => {
      let response = await res.json();
      console.log(response);
      if (response.success) {
        successOrders++
      } else {
        failedOrders++
      }
    })
    .catch(err => {
      failedOrders++
    })
  }
  return {
    successOrders,
    failedOrders
  }
}

export const createAdminBulkOrders = async (token, userId, data) => {
  let orders = await data.reduce((r,i) => {
    r.push({
      bulk_order_id: i.bulkOrderId,
      courier_name: i.courierName,
      courier_phone: i.courierPhone,
      courier_driver_name: i.courierName,
      courier_driver_phone: i.courierPhone,
      courier_status: i.courierStatus,
      courier_shipment_fee: i.courierShipmentFee,
      courier_company: i.courierCompany,
      courier_type: i.courierType,
      courier_status:i.courierStatus,
      courier_link: i.courierLink,
      delivery_date: i.deliveryDate,
      delivery_time: i.deliveryTime,
      delivery_type: i.deliveryType,
      delivery_note: i.deliveryNote,
      waybill_id: i.waybillId,
      origin_name: i.originName,
      origin_location: i.originLocation,
      origin_phone: i.originPhone,
      origin_email: i.originEmail,
      origin_note: i.originNote,
      origin_postal_code: i.originPostalCode,
      receiver_name: i.receiverName,
      receiver_location: i.receiverLocation,
      receiver_phone: i.receiverPhone,
      receiver_email: i.receiverEmail,
      receiver_note: i.receiverNote,
      receiver_postal_code: i.receiverPostalCode,
      items: i.items,
      payment_type: i.paymentType,
      status: i.status,
    });
    return r;
  },[]);

  return fetch(`${API}/v1/admin/orders/bulk`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({orders, user_id:userId})
  })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
};


export const getOrders = (filters) => {
  const testData = localStorage.getItem('biteship_test_data') === 'active' ? "test_data=true" : "";

  let confirmedDates = "";
  if (filters.confirmedStartDate) {
    confirmedDates = `&confirmed_start_date=${filters.confirmedStartDate}&confirmed_end_date=${filters.confirmedEndDate}`
  };

  let tagsText = "";
  if (filters.tags.length > 0) {
    tagsText = `&tags=${filters.tags.join()}`;
  };

  let createdDates = "";
  if (filters.createdStartDate) {
    createdDates = `&created_start_date=${filters.createdStartDate}&created_end_date=${filters.createdEndDate}`;
  };

  return fetch(`${API}/v1/orders?channel=dashboard&limit=${filters.limit}&page=${filters.page}${createdDates}${confirmedDates}${tagsText}&status=${filters.status.join()}&courier_codes=${filters.couriers.join()}&${testData}`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const getDownloadOrders = (filters) => {
  let confirmedDates = "";
  if (filters.confirmedStartDate) {
    confirmedDates = `&confirmed_start_date=${filters.confirmedStartDate}&confirmed_end_date=${filters.confirmedEndDate}`
  };

  let tagsText = "";
  if (filters.tags.length > 0) {
    tagsText = `&tags=${filters.tags.join()}`;
  };

  let createdDates = "";
  if (filters.createdStartDate) {
    createdDates = `&created_start_date=${filters.createdStartDate}&created_end_date=${filters.createdEndDate}`;
  };

  return fetch(`${API}/v1/orders?channel=dashboard&type=download${createdDates}${confirmedDates}${tagsText}&status=${filters.status.join()}&courier_codes=${filters.couriers.join()}`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const searchOrders = (value,token) => {
  return fetch(`${API}/v1/search`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({value})
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};


export const getOrder = (token,id) => {
  return fetch(`${API}/v1/orders/${id}`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
};


export const getOrderByAdmin = (token,id,type) => {
  return fetch(`${API}/v1/admin/orders/${id}/${type}`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
};

export const getOrderForPayment = (orderId) => {
  return fetch(`${API}/v1/orders/${orderId}/payment`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const deleteOrder = (token, orderId, cancellationReason,environment) => {
  return fetch(`${API}/v1/orders/${orderId}?environment=${environment}`,{
    mode: 'cors',
    method: "DELETE",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      status:'cancelled',
      cancellation_reason:cancellationReason
    })
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateOrder = (type, token, orderId, order) => {
  let data;
  if (type === 'admin') {
    data = {
      origin_coordinate:order.originCoordinate
    }
  } else {
    data = {
      destination_address:order.destinationAddress,
      destination_coordinate:order.destinationCoordinate,
      destination_postal_code:order.destinationPostalCode,
      destination_note:order.destinationNote,
      delivery_date:moment().format('YYYY-MM-DD'),
      delivery_time:moment().add(10,'minutes').format('HH:mm:ss'),
    };
  }
  

  return fetch(`${API}/v1/orders/${orderId}`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
};

export const updateOrderStatus = (token, orderId, status, env) => {
  return fetch(`${API}/v1/orders/${orderId}/confirm?environment=${env}`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateTestOrderStatus = (token, orderId, status) => {
  return fetch(`${API}/v1/orders/${orderId}/update_status_test?environment=development`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({status})
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateTestOrderPrice = (orderId) => {
  return fetch(`${API}/v1/orders/${orderId}/update_price_test?environment=development`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateTestOrderWaybill = (orderId) => {
  return fetch(`${API}/v1/orders/${orderId}/update_waybill_id_test?environment=development`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const getAdminOrders = (token) => {
  return fetch(`${API}/v0.9/admin/orders`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const getAdminOrdersByStatus = (status, token) => {
  if (status === 'delivered' || status === 'cancelled') {
    alert("file too much to load")
  } else {
    return fetch(`${API}/v1/admin/orders/status/${status}`,{
      mode: 'cors',
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
  }
};

export const getAdminOrdersGroupWithUsers = (token) => {
  return fetch(`${API}/v1/admin/orders/group/users`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateAdminOrderStatus = (token, orderId, status, data, isForced) => {
  let body = {
    courier_tracking_id: data.courierTrackingId,
    courier_waybill_id: data.courierWaybillId,
    booking_type: data.courierType,
    status: status,
    company: data.courierCompany,
    link: data.courierLink,
    driver_name: data.courierName,
    driver_phone: data.courierPhone,
    event_date: moment().format(),
    cancellation_reason: "",
  };

  let extraText;
  if (isForced) {
    extraText = `is_forced=true`
  }
  return fetch(`${API}/v1/admin/orders/${orderId}/status?${extraText}`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateAdminOrderConfirm = (token, orderId, status) => {
  return fetch(`${API}/v1/admin/orders/${orderId}/placed`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({status})
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const confirmAdminBatchPlacedOrders = async (token, orders, status) => {
  let failedOrders = 0;
  let successOrders = 0;
  for (let i = 0; i < orders.length; i++) {
    let data = orders[i];
    await fetch(`${API}/v1/admin/orders/${data.orderId}/placed`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({status})
    })
    .then(async res => {
      let response = await res.json();
      if (response.success) {
        successOrders++
      } else {
        failedOrders++
      }
    })
    .catch(err => {
      failedOrders++
    })
  }
  return {
    successOrders,
    failedOrders
  }
}

export const confirmAdminBatchOrder = async (token,orders,status) => {
  let failedOrders = 0;
  let successOrders = 0;
  for (let i = 0; i < orders.length; i++) {
    let data = orders[i];
    let body = {
      courier_tracking_id: data.courierTrackingId,
      courier_waybill_id: data.courierWaybillId,
      booking_type: data.courierType,
      status: status,
      company: data.courierCompany,
      link: data.courierLink,
      driver_name: data.courierName,
      driver_phone: data.courierPhone,
      event_date: moment().format(),
      cancellation_reason: "",
    };

    await fetch(`${API}/v1/admin/orders/${data.orderId}/status`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    })
    .then(async res => {
      let response = await res.json();
      if (response.success) {
        successOrders++
      } else {
        failedOrders++
      }
    })
    .catch(err => {
      failedOrders++
    })
  }
  return {
    successOrders,
    failedOrders
  }
}

export const deleteAdminBatchOrders = async (token, orders, status) => {
  let failedOrders = 0;
  let successOrders = 0;
  for (let i = 0; i < orders.length; i++) {
    let data = orders[i];
    await fetch(`${API}/v1/admin/orders/${data.orderId}`,{
      mode: 'cors',
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({status})
    })
    .then(async res => {
      let response = await res.json();
      if (response.success) {
        successOrders++
      } else {
        failedOrders++
      }
    })
    .catch(err => {
      failedOrders++
    })
  }
  return {
    successOrders,
    failedOrders
  }
}

export const updateAdminOrderCourier = (token, orderId, courier) => {
  let body = {
    courier_tracking_id: courier.courierTrackingId,
    courier_waybill_id: courier.courierWaybillId,
  };

  return fetch(`${API}/v1/admin/orders/${orderId}/waybill_id_update`,{
    mode: 'cors',
    method: "PUT",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateAdminDeliveryNote = (token, orderId, note) => {
  return fetch(`${API}/v1/admin/orders/${orderId}/note`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({note})
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateAdminPrice = (token, orderId, price) => {
  return fetch(`${API}/v1/admin/orders/${orderId}/price_update`,{
    mode: 'cors',
    method: "PUT",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({price})
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        alert(error)
        console.log(error);
      })
};

export const updateAdminOrderPending = async (token, orderId,status) => {
  const res = await axios.post(`${API}/v1/admin/orders/${orderId}/pay`, {
    status:status,
    payment_method: 'bankTransfer'
  }, {
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  if(res.data.success) {
    return res.data
  } else {
    alert(res.data.message);
  }
}

export const deleteAdminOrder = (token, orderId) => {
  return fetch(`${API}/v1/admin/orders/${orderId}`, {
    mode: 'cors',
    method: "DELETE",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
      .then (res => {
        return res.json()
      })
      .catch(err => {
        alert(err)
        console.log (err)
      })
};

export const uploadOrderPaymentSlip = async (image) => {
  const data = new FormData();
  data.append('paymentSlipImage', image);
  const res = await axios.post(`${API}/v1/files/order-payment-slip`, data, {
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  if(res.data.success) {
    return res.data
  } else {
    alert(res.data.message);
  }
};

export const orderPaymentConfirmation = (orderId, paymentSlip) => {
  return fetch(`${API}/v1/orders/${orderId}/confirm`,{
    mode: 'cors',
    method: "PUT",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({paymentSlip})
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};



export const notifyReceiverWaybill = (token, orderId) => {
  return fetch(`${API}/v1/admin/orders/${orderId}/waybill_notification`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
};

export const notifyCourier = (token, orderId, carType) => {
  return fetch(`${API}/v1/admin/orders/${orderId}/notify`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({car_type:carType})
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
};

export const verifyCOD = (token, orderId, carType) => {
  return fetch(`${API}/v1/admin/orders/${orderId}/verify`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({car_type:carType})
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
};  

export const disburseCOD = (token, orderId, carType) => {
  return fetch(`${API}/v1/admin/orders/${orderId}/complete`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({car_type:carType})
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
};

export const uploadOrderFile = async (token, file) => {
  const data = new FormData();
  await data.append('orders', file);

  const res = await axios.post(`${API}/v1/files/orders`, data, {
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`
    }
  });

  if(res.data.success) {
    let resFile = await normalizeMarketPlaceFile('orders',res.data.file);
    if (resFile.success) {
      return {
        success:true,
        file: resFile.orders,
        items: resFile.items,
        price: resFile.price
      }
    } else {
      return {
        success: false,
        error: 'Gagal normalisasi data'
      }
    }
  } else {
    alert(res.data.message);
  }
};

export const uploadAdminOrderFile = async (token, file) => {
  const data = new FormData();
  await data.append('orders', file);

  const res = await axios.post(`${API}/v1/admin/files/orders`, data, {
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`
    }
  });

  if(res.data.success) {
    let resFile = await normalizeMarketPlaceFile('tokopedia',res.data.file);
    if (resFile.success) {
      return {
        success:true,
        file: resFile.orders,
        items: resFile.items,
        price: resFile.price
      }
    } else {
      return {
        success: false,
        error: 'Gagal normalisasi data'
      }
    }
  } else {
    alert(res.data.message);
  }
};

export const confirmBatchOrder = async (token, orders) => {
  let failedOrders = 0;
  let successOrders = 0;
  for (let i = 0; i < orders.length; i++) {
    await fetch(`${API}/v1/orders/${orders[i].orderId}/confirm`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(async res => {
      let response = await res.json();
      if (response.success) {
        successOrders++
      } else {
        failedOrders++
      }
    })
    .catch(err => {
      failedOrders++
    })
  }
  return {
    successOrders,
    failedOrders
  }
};

export const deleteBatchOrder = async (token, orders) => {
  let failedOrders = 0;
  let successOrders = 0;
  for (let i = 0; i < orders.length; i++) {
    await fetch(`${API}/v1/orders/${orders[i].orderId}`,{
      mode: 'cors',
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        cancellation_reason:'Cancel Bulk'
      })
    })
    .then(async res => {
      let response = await res.json();
      if (response.success) {
        successOrders++
      } else {
        failedOrders++
      }
    })
    .catch(error => {
      failedOrders++
    })
  }
  return {
    successOrders,
    failedOrders
  }
};

export const fetchPaymentData = async (token, orderId, type ) => {
  return fetch(`${API}/v1/orders/${orderId}/qris_payment`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
}

export const getPublicTracking = async (shortOrderId) => {
  return fetch(`${API}/v1/public/trackings/${shortOrderId}`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
}

export const getPublicByWaybillAndCourier = async (waybillId,courierCode) => {
  return fetch(`${API}/v1/public/trackings/${waybillId}/couriers/${courierCode}`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization:'Public'
    }
  })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.log(error);
      })
}

export const getShopifyOrders = async(token) => {
  return fetch(`${API}/v1/shopify/orders/sync`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
}

const formatAPIOrder = (data,type) => {
  let time;
  if (data.deliveryType === 'later') {
    time = data.deliveryTime
  } else {
    time = moment().format("HH:mm:ss")
  }

  let formatted = {
    destination_contact_name: data.receiverName,
    destination_contact_phone: data.receiverPhone,
    destination_address: data.receiverLocation,
    destination_note: data.receiverNote,
    destination_coordinate: data.receiverCoordinate,
    destination_postal_code: data.receiverPostalCode,
    destination_cash_on_delivery: data.receiverCashOnDelivery ? data.receiverCashOnDeliveryAmount : null,
    destination_cash_on_delivery_note: data.receiverCashOnDeliveryNote,
    destination_proof_of_delivery: data.receiverProofOfDelivery,
    destination_proof_of_delivery_note: data.receiverProofOfDeliveryNote,
    items: data.orderItems,
    origin_contact_name: data.originName,
    origin_address: data.originLocation,
    origin_contact_phone: data.originPhone,
    origin_note: data.originNote,
    origin_coordinate: data.originCoordinate,
    origin_postal_code:data.originPostalCode,
    courier_company: data.courierCompany,
    courier_type: normalizeCourierServices(data.courierCompany,data.courierType).typeSnakeFormat,
    courier_insurance: data.courierInsurance ? data.courierInsuranceAmount : null,
    delivery_date: moment(data.deliveryDate).format("YYYY-MM-DD"),
    delivery_time: time,
    delivery_type: 'later',
    price: data.price,
    payment_method: data.paymentMethod,
    order_note: data.orderNote,
    type
  }

  if (type.includes('shopify')) {
    formatted = {
      ...formatted,
      delivery_type:'now',
      shopify_order_id:data.shopifyOrderId,
      shopify_fulfillment_order_id:data.shopifyFulfillmentOrderId,
      shopify_assigned_location_id:data.shopifyAssignedLocationId
    };
  } 

  return formatted
}

export const searchTags = async (tags) => {
  return fetch(`${API}/v1/search/orders/tags`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    },
    body: JSON.stringify({value:tags})
  })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
};

export const updateOrderTags = async (id,tags) => {
  return fetch(`${API}/v1/orders/${id}/update_tags`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    },
    body: JSON.stringify({tags:tags})
  })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
}

export const fulfillOrder = async (id,fulfillmentServiceCode,addressId) => {
  return fetch(`${API}/v1/orders/${id}/fulfill`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    },
    body: JSON.stringify({
      fulfillment_service_code:fulfillmentServiceCode,
      origin_location_id:addressId
    })
  })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
}